












































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";
import difficulties from "@/config/wow/difficulties";

import { getElegantDateString, getLocaleStringFromDateString, getTimeSince } from "@/utils/date-helpers";

import { rank, classNameColorRank } from "@/utils/ranking-helpers";


/**
 * Components
 */
import CharacterCell from "@/components/_global/CharacterCell.vue";
import CharacterSpecCell from "@/components/_global/CharacterSpecCell.vue";
import CharacterSynchronizationStatus from "@/components/_global/CharacterSynchronizationStatus.vue";

/**
 * Mixins
 */
import mixinNow from "@/mixins/now-mixin";


/**
 * API
 */
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetRostersResponse } from "@/api/rosters/get-rosters.response";


/**
 * Types
 */

/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Rosters great vault page.
 */
@Component({
	components: {
		CharacterCell,
		CharacterSpecCell,
		CharacterSynchronizationStatus
	}
})
export default class GreatVaultPage extends Mixins(mixinNow) {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	difficulties = difficulties;
	getTimeSince = getTimeSince;
	getElegantDateString = getElegantDateString;
	getLocaleStringFromDateString = getLocaleStringFromDateString;

	classNameColorRank = classNameColorRank;

	/// Props
	@Prop()
	rosters!: GetRostersResponse.Roster[];

	/// Attributes
	isLoading = false;


	activeRosterID: string | null = null;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get headers() {
		const result: any[] = [
			{
				text: "",
				value: "sync",
				align: "left",
				sortable: false,
				class: "collapsing"
			},
			{
				text: this.$t("character.name"),
				value: "name",
				align: "left",
				sortable: false
			}
		];

		if (this.$vuetify.breakpoint.lgAndUp) {
			result.push({
				text: this.$t("character.class"),
				value: "class",
				align: "left"
			});
		}

		result.push(
			{
				text: this.$t("character.great_vault_score"),
				value: "greatVaultScore",
				align: "center",
				class: "whitespace-nowrap"
			},
			{
				text: "1",
				value: "greatVaultSlot1",
				align: "center",
				sortable: false
			},
			{
				text: "2",
				value: "greatVaultSlot2",
				align: "center",
				sortable: false
			},
			{
				text: "3",
				value: "greatVaultSlot3",
				align: "center",
				sortable: false
			},
			{
				text: "1",
				value: "greatVaultSlot4",
				align: "center",
				sortable: false
			},
			{
				text: "2",
				value: "greatVaultSlot5",
				align: "center",
				sortable: false
			},
			{
				text: "3",
				value: "greatVaultSlot6",
				align: "center",
				sortable: false
			}
		);

		return result;
	}

	get displayedData() {
		if (this.displayedRoster == null) {
			return [];
		}

		return this.displayedRoster.characters.sort((a, b) => {
			return ((a.role < b.role) ? 1 : (a.role > b.role) ? -1 : 0)
				|| (b.averageItemLevelEquipped - a.averageItemLevelEquipped)
				|| ((a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0);
		});
	}

	/**
	 * The current roster to display.
	 */
	get displayedRoster(): GetRostersResponse.Roster | null {
		return this.rosters.find(x => x.id == this.$route.params.rosterId) ?? null;
	}

	/// Methods
	async created() {
		this.isLoading = true;
		if (this.rosters && this.rosters.length > 0) {
			this.activeRosterID = this.rosters[0].id;
		}
		this.isLoading = false;
	}


	get rankFunctionGreatVaultScore() {
		return rank(this.displayedData.map(c => c.greatVaultScore));
	}
}
